import React, { useEffect, useRef } from 'react';

const pad2 = (n) => String(n).padStart(2, '0');

export default function TimeLeftComp({ startUnix }) {
  const ref = useRef(null);
  console.log(startUnix, 'startUnix');

  useEffect(() => {
    // normalize seconds vs ms
    const startSec = startUnix > 1e12 ? Math.floor(startUnix / 1000) : startUnix;

    const paint = () => {
      const nowSec = Math.floor(Date.now() / 1000);
      const endSec = startSec + 24 * 3600;
      const remaining = Math.max(0, endSec - nowSec); // seconds

      const hrs = Math.floor(remaining / 3600);
      const mins = Math.floor((remaining % 3600) / 60);

      if (ref.current) {
        ref.current.textContent = `Time left ${pad2(hrs)}:${pad2(mins)}`;
      }
    };

    // initial paint
    paint();

    // align to the next minute, then tick every minute
    const toNextMinute = 60000 - (Date.now() % 60000);
    const t = setTimeout(() => {
      paint();
      const id = setInterval(paint, 60000);
      // store for cleanup
      if (ref.current) ref.current.__id = id;
    }, toNextMinute);

    return () => {
      clearTimeout(t);
      if (ref.current?.__id) clearInterval(ref.current.__id);
    };
  }, [startUnix]);

  return <span ref={ref}>--:-- hrs</span>;
}
